type NormalizedPipelineSyncStatus =
  | 'in_progress'
  | 'error'
  | 'success'
  | 'warning'
  | null

const PIPELINE_SYNC_STATUS: Record<
  Exclude<NormalizedPipelineSyncStatus, null>,
  true
> = {
  in_progress: true,
  error: true,
  success: true,
  warning: true,
}

const toStringOrNull = (value: unknown): string | null => {
  if (typeof value !== 'string' && typeof value !== 'number') return null
  const result = String(value).trim()
  return result ? result : null
}

/** Converts provider status spellings to the shared synchronization union. */
export const normalizeSyncStatus = (
  value: unknown
): NormalizedPipelineSyncStatus => {
  const status = toStringOrNull(value)
    ?.toLowerCase()
    .replace(/[\s-]+/g, '_')
  if (!status) return null
  if (
    status === 'awaiting_write' ||
    status === 'awaiting_write_results' ||
    status === 'awaiting_transformation'
  ) {
    return 'in_progress'
  }
  if (status === 'failed') return 'error'
  if (status === 'successful') return 'success'
  return PIPELINE_SYNC_STATUS[
    status as Exclude<NormalizedPipelineSyncStatus, null>
  ]
    ? (status as Exclude<NormalizedPipelineSyncStatus, null>)
    : null
}
